// extracted by css-extract-rspack-plugin
export default {"cls1":"Search-cls1_Jmt","cls2":"Search-cls2_vC1 Search-cls1_Jmt"};